export const IMAGE_FORMATS = {
  PNG: "png",
  JPG: "jpg",
  JPEG: "jpeg",
};
